import React, { useState } from "react";

import Avatar from "./Avatar";

// Aviso pro anfitrião: alguém escaneou o QR e quer entrar na mesa. Aparece por
// cima de qualquer tela (cardápio, conferência, comanda), um pedido por vez.
// "Depois" só esconde o aviso neste celular: o pedido continua na lista de
// quem está na mesa (com o número em amarelo), de onde dá pra decidir.
export default function PedidoDeEntrada({ pendentes, mesa, fotoDe, darkMode, onDecidir }) {
  const [adiados, setAdiados] = useState([]);
  const [decidindo, setDecidindo] = useState(false);
  const pedido = (pendentes || []).find((p) => !adiados.includes(p.cliente_id));
  if (!pedido) return null;

  const decidir = async (aprovar) => {
    setDecidindo(true);
    await onDecidir(pedido.cliente_id, aprovar);
    setDecidindo(false);
  };
  const folha = darkMode ? "bg-zinc-900 text-zinc-100" : "bg-white text-zinc-900";

  return (
    <div className="fixed inset-0 z-[90] bg-black/55 flex items-end sm:items-center justify-center p-4" data-e2e="mesa-pedido-entrada">
      <div className={`w-full max-w-sm rounded-3xl px-6 pt-7 pb-6 text-center shadow-2xl ${folha}`}>
        <Avatar nome={pedido.nome} foto={pedido.foto} fotoDe={fotoDe} tamanho={72} className="mx-auto mb-4" />
        <h2 className="text-xl font-black leading-tight">{pedido.nome} quer entrar na mesa</h2>
        <p className="text-sm opacity-70 mt-1.5">
          Liberando, {pedido.nome} pede na conta da {mesa?.nome || "mesa"} junto com vocês.
        </p>
        <div className="mt-6 grid grid-cols-2 gap-2">
          <button type="button" disabled={decidindo} onClick={() => decidir(false)} data-e2e="mesa-recusar-entrada"
            className="h-12 rounded-full border-2 border-zinc-400/40 font-bold active:scale-[0.98] transition disabled:opacity-50">
            Recusar
          </button>
          <button type="button" disabled={decidindo} onClick={() => decidir(true)} data-e2e="mesa-liberar-entrada"
            className="h-12 rounded-full bg-primary text-primary-foreground font-black active:scale-[0.98] transition disabled:opacity-50">
            Liberar
          </button>
        </div>
        <button type="button" onClick={() => setAdiados((a) => [...a, pedido.cliente_id])}
          className="mt-3 text-xs font-semibold opacity-60 underline underline-offset-2">
          Decidir depois
        </button>
      </div>
    </div>
  );
}
